import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {PurchaseOrderDataService} from './impl/service/ngrx/purchaseOrderData.service';
import {PurchaseOrderRepository} from './impl/service/ngrx/purchaseOrder.repository';

@NgModule()
export class PurchaseOrderModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                service: PurchaseOrderRepository,
                dataService: PurchaseOrderDataService,
    ) {

        entityDataService.registerServices({
            PurchaseOrder: dataService,
        });

        entityServices.registerEntityCollectionServices({
            PurchaseOrder: service,
        });

        //  errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
